import * as React from "react";
import { CloudArrowUp28Regular, CloudArrowUp28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const TorusDeployMetricApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "TorusDeployMetric" */ "./TorusDeployMetricApp");
    return { default: namedExport.TorusDeployMetricApp };
});

export const TorusDeployMetric: TeamAppConfig = {
    title: "Torus Deploy Metric",
    regularIcon: CloudArrowUp28Regular,
    filledIcon: CloudArrowUp28Filled,
    description: "Torus deployment saturation metrics across MultiTenant, Sovereign, and Airgapped rings.",
    team: "ServiceAuth",
    publicId: "Exchange\\ServiceAuth",
    owner: "o365-service-auth-oc@microsoft.com",
    role: "*",
    tags: ["Torus", "Deployment", "Deploy Metric"],
    app: TorusDeployMetricApp,
    path: "/TorusDeployMetric"
};
